export default "__VITE_ASSET__DVadmCfk__"